import BankrateLogo from '@perpay-web/fintech/assets/images/bankrateLogo.svg';
import BestCreditOffersLogo from '@perpay-web/fintech/assets/images/bestCreditOffersLogo.svg';
import CreditCardsDotComLogo from '@perpay-web/fintech/assets/images/creditCardsDotComLogo.svg';
import CreditLandLogo from '@perpay-web/fintech/assets/images/creditLandLogo.svg';
import CreditSoupLogo from '@perpay-web/fintech/assets/images/creditSoupLogo.svg';
import experianLogo from '@perpay-web/fintech/assets/images/experianLogo.svg';
import KarmaLogo from '@perpay-web/fintech/assets/images/inputKarmaLogo.svg';
import moneyLionLogo from '@perpay-web/fintech/assets/images/moneyLionLogo.svg';
import UberLogo from '@perpay-web/fintech/assets/images/uberLogo.svg';
import WalletHubLogo from '@perpay-web/fintech/assets/images/walletHubLogo.svg';
import {
    NEW,
    APPROVED,
    REJECTED,
    CLARITY_FROZEN,
    AWAITING_DEDUCTION_SETUP,
    COMPLETE,
    UPLOAD_DOCUMENTS,
    IN_REVIEW,
    ACTIVE_FRAUD_FLAG,
    EXTENDED_ACTIVE_FRAUD_FLAG,
} from '@perpay-web/fintech/constants/cardAccountApplicationStatuses';
import {
    CREDIT_KARMA_LIGHTBOX,
    CREDIT_KARMA_INVITE_TO_APPLY,
    CREDIT_LAND,
    BEST_CREDIT_OFFERS,
    RED_VENTURES_BANKRATE,
    RED_VENTURES_BANKRATE_ITA,
    RED_VENTURES_CREDIT_CARDS_DOT_COM,
    RED_VENTURES_CREDIT_CARDS_DOT_COM_ITA,
    BULLDOG_CREDIT_SOUP,
    BULLDOG_CREDIT_SOUP_ITA,
    WALLET_HUB,
    WALLET_HUB_ITA,
    EXPERIAN_INVITE_TO_APPLY,
    EXPERIAN_ACTIVATE,
    MONEY_LION,
    MONEY_LION_ITA,
    MASTERCARD,
    PERPAY_WEBSITE,
    GOOGLE_SEARCH_ADS,
    INFLUENCER_PROMOTION,
    PERPAY_DIRECT_MAIL,
    OUT_OF_HOME_1,
    UBER,
} from '@perpay-web/fintech/constants/partnerOnboardingCodes';
import * as partnerOnboardingSteps from '@perpay-web/fintech/constants/steps/cardPartnerOnboardingSteps';

export const getPartnerOnboardingStepFromStatus = (status) => {
    switch (status) {
        case NEW:
            return partnerOnboardingSteps.SUBMITTING_STEP;
        case REJECTED:
            return partnerOnboardingSteps.DENIED_STEP;
        case CLARITY_FROZEN:
            return partnerOnboardingSteps.CLARITY_UNFREEZE_STEP;
        case UPLOAD_DOCUMENTS:
            return partnerOnboardingSteps.UPLOAD_DOCUMENTS_STEP;
        case IN_REVIEW:
            return partnerOnboardingSteps.IN_REVIEW_STEP;
        case APPROVED:
            return partnerOnboardingSteps.APPROVED_STEP;
        case AWAITING_DEDUCTION_SETUP:
            return partnerOnboardingSteps.REVIEW_DIRECT_DEPOSIT_STEP;
        case COMPLETE:
            return partnerOnboardingSteps.SUCCESS_STEP;
        case ACTIVE_FRAUD_FLAG:
            return partnerOnboardingSteps.IDENTITY_STEP;
        case EXTENDED_ACTIVE_FRAUD_FLAG:
            return partnerOnboardingSteps.EXTENDED_IDENTITY_STEP;
        default:
            return partnerOnboardingSteps.APPLICATION_ERROR_STEP;
    }
};

export const partnerOnboardingStepperNames = [
    { name: '1. About me' },
    { name: '2. Application' },
    { name: '3. Offer' },
    { name: '4. Direct Deposit' },
];

export const getPartnerOnboardingLogo = (partnerCode) => {
    switch (partnerCode) {
        case CREDIT_KARMA_LIGHTBOX:
        case CREDIT_KARMA_INVITE_TO_APPLY:
            return {
                partnerLogo: KarmaLogo,
                partnerLogoClassName: 'credit-karma',
            };
        case CREDIT_LAND:
            return {
                partnerLogo: CreditLandLogo,
                partnerLogoClassName: 'credit-land',
            };
        case BEST_CREDIT_OFFERS:
            return {
                partnerLogo: BestCreditOffersLogo,
                partnerLogoClassName: 'best-credit-offers',
            };
        case RED_VENTURES_BANKRATE_ITA:
        case RED_VENTURES_BANKRATE:
            return {
                partnerLogo: BankrateLogo,
                partnerLogoClassName: 'bankrate',
            };
        case RED_VENTURES_CREDIT_CARDS_DOT_COM_ITA:
        case RED_VENTURES_CREDIT_CARDS_DOT_COM:
            return {
                partnerLogo: CreditCardsDotComLogo,
                partnerLogoClassName: 'credit-cards-dot-com',
            };
        case BULLDOG_CREDIT_SOUP_ITA:
        case BULLDOG_CREDIT_SOUP:
            return {
                partnerLogo: CreditSoupLogo,
                partnerLogoClassName: 'credit-soup',
            };
        case WALLET_HUB_ITA:
        case WALLET_HUB:
            return {
                partnerLogo: WalletHubLogo,
                partnerLogoClassName: 'wallet-hub',
            };
        case EXPERIAN_ACTIVATE:
        case EXPERIAN_INVITE_TO_APPLY:
            return {
                partnerLogo: experianLogo,
                partnerLogoClassName: 'experian',
            };
        case MONEY_LION_ITA:
        case MONEY_LION:
            return {
                partnerLogo: moneyLionLogo,
                partnerLogoClassName: 'money-lion',
            };
        case MASTERCARD:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'mastercard',
            };
        case PERPAY_WEBSITE:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'perpay-website',
            };
        case GOOGLE_SEARCH_ADS:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'google-search-ads',
            };
        case INFLUENCER_PROMOTION:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'influencer-promotion',
            };
        case PERPAY_DIRECT_MAIL:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'perpay-direct-mail',
            };
        case OUT_OF_HOME_1:
            return {
                partnerLogo: null,
                partnerLogoClassName: 'out-of-home',
            };
        case UBER:
            return {
                partnerLogo: UberLogo,
                partnerLogoClassName: 'uber',
            };
        default:
            return {
                partnerLogo: null,
                partnerLogoClassName: '',
            };
    }
};

export const getPartnerNameFromCode = (partnerCode) => {
    switch (partnerCode) {
        case CREDIT_KARMA_LIGHTBOX:
            return 'CreditKarma LB';
        case CREDIT_KARMA_INVITE_TO_APPLY:
            return 'CreditKarma ITA';
        case CREDIT_LAND:
            return 'CreditLand';
        case BEST_CREDIT_OFFERS:
            return 'BestCreditOffers';
        case RED_VENTURES_BANKRATE:
            return 'Bankrate';
        case RED_VENTURES_BANKRATE_ITA:
            return 'Bankrate ITA';
        case RED_VENTURES_CREDIT_CARDS_DOT_COM:
            return 'CCDC';
        case RED_VENTURES_CREDIT_CARDS_DOT_COM_ITA:
            return 'CCDC ITA';
        case BULLDOG_CREDIT_SOUP_ITA:
        case BULLDOG_CREDIT_SOUP:
            return 'CreditSoup';
        case WALLET_HUB_ITA:
        case WALLET_HUB:
            return 'WalletHub';
        case EXPERIAN_INVITE_TO_APPLY:
            return 'Experian ITA';
        case EXPERIAN_ACTIVATE:
            return 'Experian Activate';
        case MONEY_LION:
            return 'MoneyLion';
        case MONEY_LION_ITA:
            return 'MoneyLion ITA';
        case MASTERCARD:
            return 'Mastercard';
        case PERPAY_WEBSITE:
            return 'Perpay Website';
        case GOOGLE_SEARCH_ADS:
            return 'Google Search Ads';
        case INFLUENCER_PROMOTION:
            return 'Influencer Promotion';
        case PERPAY_DIRECT_MAIL:
            return 'Perpay Direct Mail';
        case OUT_OF_HOME_1:
            return 'Out of Home Marketing';
        case UBER:
            return 'Uber';
        default:
            return null;
    }
};
